export default __webpack_public_path__ + "static/media/MSSQL.8f9d45e7.jpg";